import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { IRequestReviewNote } from '../models/RequestReviewNote';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';

const LIMIT = 10;

export default class RequestReviewNoteStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.reviewNotePages = 0;
                this.RequestReviewNoteRegistry.clear();
            }
        )
    }

    RequestReviewNoteRegistry = new Map();
    RequestReviewNote: IRequestReviewNote | null = null;
    loadingInitialReviewNotes = false;
    submitting = false;
    target = "";

    requestReviewNoteCount = 0;
    reviewNotePages = 0;

    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.reviewNotePages ? this.reviewNotePages * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }


    get totalReviewNotePages() {
        return Math.ceil(this.requestReviewNoteCount / LIMIT);
    }

    setPageReviewNotes = (reviewNotePages: number) => {
        this.reviewNotePages = reviewNotePages;
    }

    get requestReviewNotesById() {
        return this.groupRequestReviewNotesById(Array.from(this.RequestReviewNoteRegistry.values()));
    };

    groupRequestReviewNotesById(requestReviewNotes: IRequestReviewNote[]) {
        const sortedRequests = requestReviewNotes.sort(
            (a, b) => parseInt(b.id) - parseInt(a.id)
        )

        return Object.entries(sortedRequests.reduce((requestReviewNotes, requestReviewNote) => {
            const id = requestReviewNote.id;
            requestReviewNotes[id] = requestReviewNotes[id] ? [...requestReviewNotes[id], requestReviewNote] : [requestReviewNote];
            return requestReviewNotes;
        }, {} as { [key: string]: IRequestReviewNote[] }));
    }



    get requestReviewNotesByDate() {
        return Array.from(this.RequestReviewNoteRegistry.values()).sort(
            (a, b) => b.dateCreated - a.dateCreated
        );
    };

    loadRequestReviewNotes = async (requestReviewId: string) => {
        this.loadingInitialReviewNotes = true;
        try {
            const requestReviewNotesEnvelope = await agent.RequestReviewNotes.list(requestReviewId);
            const { requestReviewNotesDto, requestReviewNoteCount } = requestReviewNotesEnvelope;

            runInAction('loadRequestReviewNotes', () => {
                requestReviewNotesDto.forEach((requestReviewNoteDto) => {
                    this.RequestReviewNoteRegistry.set(requestReviewNoteDto.id, requestReviewNoteDto);
                });
                this.requestReviewNoteCount = requestReviewNoteCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadRequestReviewNotes', () => {
            this.loadingInitialReviewNotes = false;
        });
    };

    loadRequestReviewNote = async (id: string) => {
        let RequestReviewNote = this.getRequestReviewNote(id);
        if (RequestReviewNote) {
            this.RequestReviewNote = RequestReviewNote;
            return RequestReviewNote;
        }
        else {
            this.loadingInitialReviewNotes = true;
            try {
                RequestReviewNote = await agent.RequestReviewNotes.details(id);
                runInAction('getting activity', () => {
                    this.RequestReviewNote = RequestReviewNote;
                    this.RequestReviewNoteRegistry.set(RequestReviewNote.id, RequestReviewNote);
                    this.loadingInitialReviewNotes = false;
                })
                return RequestReviewNote;
            } catch (error) {
                toast.error('problem submitting data');
            }
        }
        runInAction('loadRequestReviewNotes', () => {
            this.loadingInitialReviewNotes = false;
        });
    };

    getRequestReviewNote = (id: string) => {
        return this.RequestReviewNoteRegistry.get(id);
    }

    ClearRequestReviewNote = () => {
        this.RequestReviewNote = null;
    }


    createRequestReviewNote = async (requestReviewNote: IRequestReviewNote) => {
        this.submitting = true;
        try {
            await agent.RequestReviewNotes.create(requestReviewNote);
            runInAction('create RequestReviewNote', () => {
                this.submitting = false;
                toast.success('Saved');

                this.rootStore.requestReviewStore.incrementRequestReviewNote(requestReviewNote.requestReviewId);

                this.rootStore.modalStore.closeModal();

            });

        } catch (error) {
            runInAction('create RequestReviewNote error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    deleteRequestReviewNote = async (requestReviewNoteId: string) => {
        this.submitting = true;
        try {
            await agent.RequestReviewNotes.delete(requestReviewNoteId);


            runInAction('delete RequestReviewNote', () => {
                this.submitting = false;
                this.RequestReviewNoteRegistry.delete(requestReviewNoteId);
            });
            toast.success('Saved');

        } catch (error) {
            runInAction('delete RequestReviewNote error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editRequestReviewNote = async (requestReviewNote: IRequestReviewNote) => {
    };



}
decorate(RequestReviewNoteStore, {
    RequestReviewNoteRegistry: observable,
    RequestReviewNote: observable,
    loadingInitialReviewNotes: observable,
    submitting: observable,
    target: observable,
    requestReviewNoteCount: observable,
    reviewNotePages: observable,
    predicate: observable,

    loadRequestReviewNote: action,
    loadRequestReviewNotes: action,
    ClearRequestReviewNote: action,
    setPredicate: action,
    setPageReviewNotes: action,
    createRequestReviewNote: action,
    editRequestReviewNote: action,

    requestReviewNotesById: computed,
    requestReviewNotesByDate: computed,
    axiosParams: computed,
    totalReviewNotePages: computed
});